import { Collapse, Fade, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Children, PropsWithChildren } from "react";
import { useMcpDrawerContext } from "./drawer-context";

interface DrawerItemGroupProps extends PropsWithChildren{
    Icon?: React.FC,
    title: string
}

export default function DrawerItemGroup({
    Icon,
    title,
    children
}: DrawerItemGroupProps) {
    const { drawerOpen, selectedGroup, setSelectedGroup } = useMcpDrawerContext();

    const count = Children.map(children, c=>c)?.filter(c=>Boolean(c)).length||0;
    if(count <= 0) return;

    const selected = selectedGroup === title;

    const handleToggle = ()=>{
        if(selected) setSelectedGroup(undefined);
        else setSelectedGroup(title);
    }

    return <>
        <ListItemButton onClick={handleToggle}>
            {Icon&&<ListItemIcon> <Icon /> </ListItemIcon>}
            <Fade in={drawerOpen}>
                <ListItemText primary={title} />
            </Fade>
            <Fade in={drawerOpen}>
                {selected ? <ExpandLess /> : <ExpandMore />}
            </Fade>
        </ListItemButton>
        <Collapse in={selected && drawerOpen} unmountOnExit>
            {children}
        </Collapse>
    </>
}